import React from 'react'
import { makeSubheader } from './styled'

export const RawSubheader = makeSubheader('h5')

function Subheader(props) {
  return <RawSubheader {...props} />
}

export default Subheader
